module.exports = __webpack_public_path__ + "img/DropDownLists.ff04c79d.svg";